import { SingletonRedirect } from "@/components/SingletonRedirect";

export function SettingsList() {
  return <SingletonRedirect resource="settings" />;
}
